import { render, staticRenderFns } from "./dev-param-form2.vue?vue&type=template&id=d4761a8e&scoped=true&"
import script from "./dev-param-form2.vue?vue&type=script&lang=js&"
export * from "./dev-param-form2.vue?vue&type=script&lang=js&"
import style0 from "./dev-param-form2.vue?vue&type=style&index=0&id=d4761a8e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4761a8e",
  null
  
)

export default component.exports